import '@fontsource/archivo-black'
import '@fontsource/barlow/400.css'
import '@fontsource/barlow/600.css'
import '@fontsource/barlow/700.css'
import '@/styles/themes/shouldi.scss'
import '@/styles/base.scss'
import { createApp } from 'vue'
import { VueQueryPlugin } from '@tanstack/vue-query'
import { vReveal } from '@/shared/directives/reveal'
import App from './App.vue'

createApp(App).use(VueQueryPlugin).directive('reveal', vReveal).mount('#app')
